import { render } from "./CharacterBlock.vue?vue&type=template&id=13492414"
import script from "./CharacterBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./CharacterBlock.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/apps/CharacterBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13492414"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13492414', __exports__)) {
    api.reload('13492414', __exports__)
  }
  
  module.hot.accept("./CharacterBlock.vue?vue&type=template&id=13492414", () => {
    api.rerender('13492414', render)
  })

}


export default __exports__